// extracted by mini-css-extract-plugin
export default {"integration-table__action":"ConnectedApps_integration-table__action__ll2wo","integration-table__action--button":"ConnectedApps_integration-table__action--button__VebKs"};